export default "__VITE_ASSET__92d12d87__"